import api from './api';
import { AuthResponse } from '../types';

export const register = async (
    fullName: string,
    email: string,
    password: string
): Promise<AuthResponse> => {
    const response = await api.post('/api/auth/register', {
        fullName,
        email,
        password,
    });
    return response.data;
};

export const login = async (
    email: string,
    password: string
): Promise<AuthResponse> => {
    const response = await api.post('/api/auth/login', {
        email,
        password,
    });
    return response.data;
};

export const forgotPassword = async (email: string): Promise<string> => {
    const response = await api.post('/api/auth/forgot-password', { email });
    return response.data;
};

export const resetPassword = async (
    token: string,
    newPassword: string
): Promise<string> => {
    const response = await api.post('/api/auth/reset-password', {
        token,
        newPassword,
    });
    return response.data;
};

export const getCurrentUser = async (): Promise<AuthResponse> => {
    const response = await api.get('/api/auth/me');
    return response.data;
};